<template>
  <base-modal modal-content-class="unsub">
    <div class="content">
      <h1>{{ $_getTranslations.home_modals_unsubscribe_title }}</h1>

      <p>
        <span>{{ userDetails.username }}</span>,
        {{ $_getTranslations.home_modals_unsubscribe_user_unsubscribe }}
      </p>

      <p>{{ $_getTranslations.home_modals_unsubscribe_if_you_unsubscribe }}</p>

      <h2>{{ $_getTranslations.home_modals_unsubscribe_continue_message }}</h2>

      <p>
        {{ $_getTranslations.home_modals_unsubscribe_sms_instructions_pt1 }}
        <span class="white_bold">
          {{ $_translateTextByOperator({key: 'home_modals_unsubscribe_sms_instructions_pt2'}) }}
          {{ $_getTranslations.home_modals_unsubscribe_sms_instructions_pt3 }}
          {{ $_translateTextByOperator({key: 'home_modals_unsubscribe_sms_instructions_pt4'}) }}
        </span>
      </p>
    </div>
  </base-modal>
</template>

<script>
import {mapState} from 'vuex'
import BaseModal from '../../common/modal/BaseModal'
import translationMixin from '../../../common/mixins/translation'

export default {
  name: 'unsubscribe-sms',
  components: {
    BaseModal
  },
  mixins: [translationMixin],
  computed: {
    ...mapState('common', [
      'userDetails'
    ])
  }
}
</script>




// WEBPACK FOOTER //
// src/components/home/modals/UnsubscribeSms.vue